module.exports = __webpack_public_path__ + "static/globe-65a1b2b4ed0028b38e841ca8c1d49e81.svg";